import { useRealtimeChannel } from '@/hooks/useRealtimeChannel'
import { queryClient } from '@/lib/query'
import { type CursorPage, type ResourceRow, fetchList } from '@/lib/resources'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

interface Options {
  search?: string
  pageSize?: number
  cursor?: string
  filters?: Record<string, string | undefined>
  channel?: string
}

export function useResourceList(
  key: string | undefined,
  options: Options = {}
) {
  const { search, pageSize, cursor, filters, channel } = options

  const params = useMemo(() => {
    const out: Record<string, string | number | undefined> = {
      search: search?.trim() || undefined,
      page_size: pageSize,
      cursor
    }
    if (filters) Object.assign(out, filters)
    return out
  }, [search, pageSize, cursor, filters])

  const queryKey = ['admin-resource-list', key, params]

  // Invalidate on realtime events touching this resource
  useRealtimeChannel(channel, () => {
    if (!key) return
    queryClient.invalidateQueries({ queryKey: ['admin-resource-list', key] })
  })

  return useQuery<CursorPage<ResourceRow>>({
    queryKey,
    queryFn: () => fetchList(key!, params),
    enabled: Boolean(key)
  })
}
